// extracted by mini-css-extract-plugin
export default {"consent":"CookieModal_consent__uxFYs","consentGrid":"CookieModal_consentGrid__GSJLM","buttonGrid":"CookieModal_buttonGrid__cJVpu","consentModal":"CookieModal_consentModal__gNJr3"};